import ReactDOM from 'react-dom';
import { useEffect, useState } from 'react';
import axios from 'axios';
import LoadingIndicator from '3-components/LoadingIndicator/LoadingIndicator';
import BarChart from '3-components/Chart/BarChart';
import LineChart from '3-components/Chart/LineChart';
import { type BarChartVariantType, type ChartAnnotationType } from '3-components/Chart/_chart';

const APP_CLASS = 'chart-display-app';

type ChartDisplayProps = {
    chartType: string;
    chartVariant: BarChartVariantType;
    chartHeight?: number | string;
    maxValue?: number | string;
    yLabel?: string;
    xLabel?: string;
    dataSrc?: string;
    dataJson?: any; // eslint-disable-line @typescript-eslint/no-explicit-any
    annotation?: ChartAnnotationType;
}

const ChartDisplayApp = (props: ChartDisplayProps): JSX.Element => {
    const { chartType, dataSrc, chartHeight, chartVariant, maxValue, dataJson, annotation, xLabel, yLabel } = props;

    const [data, setData] = useState(undefined);

    useEffect(() => {
        if (dataSrc) {
            axios.get(dataSrc)
                .then(response => {
                    if (response.data) {
                        setData(response.data);
                    }
                });
        }
    }, [dataSrc]);

    useEffect(() => {
        if (dataJson) {
            setData(dataJson);
        }
    }, [dataJson]);

    if (chartType === 'bar' && data) {
        return (
            <BarChart
                chartData={data}
                chartVariant={chartVariant}
                maxValue={parseInt(`${maxValue}`)}
                yLabel={yLabel}
                xLabel={xLabel}
                expectedHeight={parseInt(`${chartHeight}`)}
                annotation={annotation}
            />
        );
    }
    if (chartType === 'line' && data) {
        return (
            <LineChart
                chartData={data}
                maxValue={parseInt(`${maxValue}`)}
                expectedHeight={parseInt(`${chartHeight}`)}
                annotation={annotation}
                yLabel={yLabel}
                xLabel={xLabel}
            />
        );
    }

    return (
        <LoadingIndicator />
    );
};

document.addEventListener('DOMContentLoaded', () => {
    const initChartPanelReact = (): void => {
        const els = document.getElementsByClassName(`${APP_CLASS}`);
        if (els.length > 0) {
            for (let i = 0; i < els.length; i += 1) {
                const el = els.item(i) as HTMLElement;
                const elProps = el?.dataset.props || '{}';
                const propsObj = JSON.parse(elProps);

                if (el) {
                    ReactDOM.render(
                        /* eslint-disable-next-line react/jsx-props-no-spreading */
                        <ChartDisplayApp {...propsObj} />,
                        el
                    );
                }
            }
        }
    };

    // delay initiation so chart panel that is used inside other component can work (e.g: in Tab)
    setTimeout(initChartPanelReact, 100);
});


